// import setTrackingEvents from '../../services/trackingService';
import './footer.component.scss';

const copyrightYear = new Date().getFullYear();

export default function FooterView() {
    return {
        // oncreate: () => setTrackingEvents('a.target-link'),
        view: () => (<>
            <div class="footer__col social-follow">
                <div class="social-icons">
                    <a class="instagram-icon target-link" data-type="social" data-target="instagram" href="https://www.instagram.com/voidhunterofficial/" target="_blank">
                        <img src="/assets/ig-icon-white.png" alt="Instagram icon" />
                    </a>
                    <a class="facebook-icon target-link" data-type="social" data-target="facebook" href="https://www.facebook.com/voidhunterofficial/" target="_blank">
                        <img src="/assets/fb-icon-white.png" alt="Facebook icon" />
                    </a>
                </div>
                <div class="bandsintown-follow">
                    <iframe src="https://bandsintown.com/artist/id_15560541/track_button?actor_type=ARTIST&background_color=rgba(231,225,212,1)&hover_color=rgba(231,225,212,0.8)&font=Roboto&bitIcon=show&text=FOLLOW&text_color=rgba(0,0,0,1)&locale=en&display_tracker_count=hide&size=large"
                        title="newsletter-widget"
                        height="35"
                        width="150"
                        scrolling="no"
                        frameborder="0"
                        style="border:none; overflow:hidden;"
                        allowtransparency="true">
                    </iframe>
                </div>
            </div>
            <div class="footer__col copyright">Copyright {copyrightYear} Void Hunter / My Checkbook Records. All rights reserved.</div>
        </>),
    };
}
